import React from "react";
import PropTypes from "prop-types";
import RaEligibilityBtn from "features/referral-answer/eligibility/eligibility-btn";

const InsuranceVerification = ({ order, orderId }) => {
  if (
    order?.insurance_verification_type === "ReferralAnswer" &&
    order?.eligible_for_insurance_verification
  ) {
    return <RaEligibilityBtn orderId={orderId} />;
  } else if (
    order?.insurance_verification_type === "ReferralAnswer" &&
    !order?.eligible_for_insurance_verification
  ) {
    return (
      <div
        style={{
          marginTop: "20px",
          gridColumn: "1/-1",
          fontWeight: "bold",
          color: "red",
          fontSize: "1rem"
        }}
      >
        Not Eligible for Insurance Verification
      </div>
    );
  }
  return null;
};

InsuranceVerification.defaultProps = {};

InsuranceVerification.propTypes = {
  order: PropTypes.object,
  orderId: PropTypes.string.isRequired
};

export default InsuranceVerification;
